import { APIClient } from "./axiosClient";

export class RoleApi {
    static getAllRoles() {
        return APIClient('/user/getAllRoles');
    }

    static getPermissionsUsingRoleId(roleId: string | number) {
        return APIClient(`/user/getPermissionsUsingRoleId?roleId=${roleId}`);
    }

    static addPermissionsToRole(payload: { roleId: number | string; permissionCodesToBeAdded: string[] }) {
        return APIClient('/user/addPermissionsToRole', payload, { requestType: 'post' });
    }

    static deletePermissionsFromRole(payload: { roleId: number | string; permissionCodesToBeDeleted: string[] }) {
        return APIClient('/user/deletePermissionsFromRole', payload, { requestType: 'post' });
    }

    static getAllPermissions() {
        return APIClient('/user/getAllPermissions');
    }
} 